import { render, staticRenderFns } from "./VToolbarTitle.vue?vue&type=template&id=f0a245a6&scoped=true&"
import script from "./VToolbarTitle.vue?vue&type=script&lang=js&"
export * from "./VToolbarTitle.vue?vue&type=script&lang=js&"
import style0 from "./VToolbarTitle.vue?vue&type=style&index=0&id=f0a245a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a245a6",
  null
  
)

export default component.exports